import styled from "styled-components";
import { WaveSurfer, Region } from "wavesurfer-react";
import { Scroll, Section } from "styles/GlobalCss";
import { Box, Button, IconButton, Stack } from "@mui/material";
import { dark, gray } from 'styles/theme'
import { black } from "styles/theme";
import { styled as muiStyled } from '@mui/material/styles';
import { thirdly } from "styles/theme";

export const FooterSettingStyles = muiStyled(Box)(({ selected }) => ({
    display: "grid",
    justifyContent: "space-between",
    columnGap: 5,
    gridTemplateColumns: "repeat(3, 1fr)",
    '.speed': {
        width: 240,
        display: "flex",
        alignItems: "center",
        columnGap: 7
    },
    '.left': {
        justifyContent: "start"
    },
    '.right': {
        justifyContent: "end"
    },
    '.center': {
        justifyContent: 'center'
    },
    '.section': {
        display: "flex"
    },
    '.play-btns': {
        display: "flex",
        columnGap: 6,
        alignItems: "center",
        '.MuiButtonBase-root.MuiIconButton-root': {
            background: thirdly
        },
        '.MuiButtonBase-root.MuiButton-root.MuiLoadingButton-root': {
            textTransform: "capitalize"
        }
    }
}));

export const AudioTitleStyles = muiStyled(Box)(({ selected }) => ({
    display: "flex",
    justifyContent: "space-between",
    columnGap: 10,
    height: 30,
    '.txt': {
        whiteSpace: "nowrap"
    },
    '.header-items': {
        display: "flex",
        columnGap: 10,
    }
}));


export const AudioEditorStyles = muiStyled(Box)(({ selected }) => ({
    '.audio': {
        width: "100%",
        direction: "rtl",
        height: 100,
        width: "calc(100% - 50px)",
        position: "relative"
    }
}));

export const HeaderSettingStyles = muiStyled(Box)(({ selected }) => ({
    display: "flex",
    justifyContent: "space-between",
    columnGap: 10,
    width: "100%",
    '.rate-btns': {
        display: "flex",
        columnGap: 5
    },
    '.update-assessment': {
        display: "flex",
        columnGap: 5,
    }
}));

const Duration = styled.div`

`

const ActionBtn = styled(Button)`

`

const Action = styled(IconButton)`
background:#E9F0FD !important;
color:${dark} !important;
`

const WrapActions = styled.div`
display:flex;
flex-direction:column;
`

const WrapStack = styled(Stack)`
justify-content:center;
`

const AudioContent = styled.div`

`

const WrapRegion = styled(Region)`

`

const WrapWaveSurfer = styled(WaveSurfer)`

`

const Message = styled.div`
display: flex;
align-items: center;
`

const WrapRecord = styled.div`
display: flex;
flex-direction: column;
flex-shrink: 0;
${Section};
padding:5px !important;
flex-direction: ${props => props.$changeSetting && `column`};
height:auto;
display:flex;
column-gap: 10px;
justify-content: center;
flex-direction: ${props => !props.$basic && "column"};
row-gap:10px;
height:${props => props.$basic && '150px'};
display:${props => props.$hidden && 'none'};

// // ${Section};
// height:auto;
// display:flex;
// justify-content: center;
// flex-direction: ${props => !props.$basic && "column"};
// row-gap:10px;
// align-items: center;
// height:${props => props.$basic && '40px'};
// display:${props => props.$hidden && 'none'};
// column-gap: 10px;

#play{
    width:40px !important;
    height:40px !important;
}
${Scroll};

.record{
    width:100% !important;
    direction: ltr;
    ${Scroll};
    overflow-x:hidden !important;
    overflow-y:hidden !important;

}



.scroll{
    overflow-x:hidden !important;
    overflow-y:hidden !important;

    ${Scroll};
}


.linearProgress{
    width:100% !important;
}


.action-btns{
    display:flex;
    column-gap: 10px;
}

`

const BasicRecord = styled.div`
    width:calc(100% - 120px) !important;
    direction: ltr;
    display: ${props => props.$hidden && 'none'};
    height: 100%;
    ${Scroll};
`

const WrapWavesurferPlayer = styled(WaveSurfer)`
${Scroll};
overflow:hidden;
height:100%

    #waveform {
            transform: scaleX(-1);
        }
        #waveform-controls {
            transform: scaleX(-1);
        }
        .marker-label {
            transform: scaleX(-1);
        }

`

const WrapWavesurferPlayerRef = styled.div`
${Scroll};
overflow:hidden;
height:100%

`

const Rate = styled.div`
display: flex;
column-gap: 5px;
display: flex;
justify-content: space-between;
height:30px;
`

const RateButton = styled(Button)`
background:${props => props.selected && `${gray} !important`};
color:${props => props.selected && `${dark} !important`};

${props => props.$rightIcon && `
direction: ltr !important;
`}
`

const ChangeAudioSetting = styled.div`
    display: flex;
    column-gap: 5px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`


const ZoomIn = styled.div`
.zoom-in{
    display: flex;
    column-gap: 10px;
    font-size:14px
}

.slider{
    width: 170px !important;

.MuiSlider-thumb{
 
 }    

}

.
`

const AudioTitle = styled.div`
height:30px;
text-align: start;
color:${black};
align-items:center;
white-space: nowrap;
`

export { AudioTitle, BasicRecord, WrapActions, Action, WrapWavesurferPlayerRef, ZoomIn, WrapStack, ChangeAudioSetting, Rate, Duration, RateButton, WrapWaveSurfer, WrapRegion, AudioContent, Message, WrapRecord, WrapWavesurferPlayer, ActionBtn }